<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import AddCampaignFlowModal from "@/view/components/campaigns/AddCampaignFlowModal.vue";
import DataTableSection from "@/view/components/helper/datatable/datatableSingleFetch.vue";
import {
  getSegments,
  removeFlow,
  addFlow,
  addFlowTrigger
} from "@/api/campaigns.js";
import moment from "moment";
const startOfMonth = moment().format("YYYYMMDDhmmss");
export default {
  name: "flows",
  components: {
    AddCampaignFlowModal,
    DataTableSection
  },
  data() {
    return {
      search: "",
      singleSelect: false,
      selected: [],
      items: [],
      snackbar: false,
      text: "Loading campaing flow...",
      timeout: 2000,
      segments: [],
      loading: true,
      dialogDelete: false,
      dialogMsg: "Are you sure you want to delete this campaing flow?",
      item: null,
      add: false,
      tableDataParam: {
        getters: 'getFlows',
        dispatchFunction: 'getFlows',
        headers: [
          {
            text: "Flow Name",
            align: "start",
            sortable: false,
            value: "name"
          },
          { text: "Date Created", value: "created" },
          { text: "", value: "action" }
        ]
      },
      customRenderers: [
        {
          field: "name",
        },{
          field: "action",
        }
      ] 
    };
  },
  async beforeMount() {
  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    config() {
      return this.layoutConfig();
    },
    searchTrigger() {
      return this.search;
    }
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Campaign Flows" }]);
    this.$store.commit("setLocationVisibile", true);
    this.segments = await getSegments();
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
          document.title = to.meta.title || 'Aben';
      }
    },
    searchTrigger(q) {
      let componentEvent = this.$refs.dataTableComponent
      componentEvent.updateSearchField(q)
    }
  },
  methods: {
    showFlowBuilder(item) {
      this.$router.push(`/flows/builder/${item.id}`);
    },
    removeItem(item) {
      this.dialogDelete = true;
      this.item = item;
    },
    async removeItemConfirm() {
      let item = this.item;
      this.dialogDelete = false;
      // console.log(item);
      const response = await removeFlow(item.id);
      if (response) {
        this.snackbar = true;
        this.text = `Campaign flow ${item.name} has been removed.`;
        setTimeout(() => {
          this.$store.dispatch("getFlows");
        }, 1000);
      }
    },
    closeDelete() {
      this.item = null;
      this.dialogDelete = false;
    },
    async addCampaign() {
      this.add = false;
      this.add = true;
      let data = {
        name: `Flow-draft-${startOfMonth}`
      };
      const payload = JSON.parse(JSON.stringify(data));
      // console.log(payload);
      const response = await addFlow(payload);
      // console.log(response);
      if (response) {
        this.$store.dispatch("getFlows");
        let payload2 = {
          trigger_type: "CAMPAIGN_FLOW_TRIGGER_CLICKS_A_LINK",
          trigger_details: {
            url: ""
          },
          scheduled_date: moment().format("YYYY-MM-DD HH:mm:ss"),
          initial: true,
          flow: response.id,
          previous_flow_item: null
        };
        const response2 = await addFlowTrigger(payload2);
        if (response2) {
          this.$router.push(`/flows/builder/${response.id}`);
        }
      }
    }
  }
};
</script>

<template>
  <v-app>
    <v-main>
      <v-card flat>
        <v-row justify="space-between" style="padding: 10px">
          <v-col cols="12" md="8">
            <v-btn class="mr-4" depressed tile @click="addCampaign">
              <v-icon left> mdi-plus-box </v-icon> Add
            </v-btn>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <div id="tb-templates">
          <data-table-section
            :tableData="this.tableDataParam"
            :customRenderers="this.customRenderers"
            :isSelectEnabled="false"
            ref="dataTableComponent"
          >
            <template v-slot:nameparams="{ item }">
                <v-btn
                  text
                  color="primary"
                  class="ml-n5"
                  @click="showFlowBuilder(item)"
                >
                  {{ item.name }}
                </v-btn>
              </template>
              <template v-slot:actionparams="{ item }">
                <v-btn icon @click="removeItem(item)">
                  <v-icon left> mdi-delete </v-icon>
                </v-btn>
              </template>
        </data-table-section>
        </div>
        <v-dialog v-model="dialogDelete" max-width="510px">
          <v-card>
            <v-card-title class="headline">{{ dialogMsg }}</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="removeItemConfirm">
                OK
              </v-btn>
              <v-btn color="blue darken-1" text @click="closeDelete">
                Close
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar" :timeout="timeout">
          {{ text }}
          <template v-slot:action="{ attrs }">
            <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
        <add-campaign-flow-modal v-if="add"></add-campaign-flow-modal>
      </v-card>
    </v-main>
  </v-app>
</template>
